import moment from 'moment'
import 'moment/locale/de'
import React from 'react'
import { render } from 'react-dom'
import Cookies from 'js-cookie'

import App from './App'
import registerServiceWorker from './registerServiceWorker'

const startup = () => {
  moment.locale('de')

  render(<App />, document.getElementById('root'))

  registerServiceWorker()
}

const params = new URLSearchParams(window.location.search)

function setCookieFromParam(paramName) {
  const paramValue = params.get(paramName)
  if (paramValue) {
    Cookies.set(`gradoo_${paramName}`, paramValue)
  }
}

const GRADOO_PARAMS = ['groups', 'name', 'phone', 'email']
GRADOO_PARAMS.forEach(paramName => setCookieFromParam(paramName))
window.history.pushState({}, document.title, window.location.pathname)

if (Cookies.get('gradoo_groups')) {
  startup()
} else {
  window.location =
    process.env.NODE_ENV === 'production'
      ? 'https://gradoo.app/splash?lang=de&cc=1'
      : 'http://localhost:19006/splash?lang=en&cc=1'
}



// WEBPACK FOOTER //
// ./src/index.js